/*!--------------------------------------------------------------------------
// <copyright file="GSS.help.ts" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
var GSS;
(function (GSS) {
    var help;
    (function (help) {
        var metaData;
        (function (metaData) {
            var ids;
            (function (ids) {
                ids.contactSupport = 'contactSupport'.gssGetId();
                ids.divWidgetContent = 'divWidgetContent'.gssGetId();
                ids.divTileContent = 'divTileContent'.gssGetId();
                ids.searchTextBox = 'SearchText'.gssGetId();
                ids.helpResult = 'helpResult'.gssGetId();
                ids.phoneLink = 'phoneLink'.gssGetId();
                ids.emailLink = 'emailLink'.gssGetId();
                ids.contactUs = 'contactUs'.gssGetId();
                ids.fullName = 'fullName'.gssGetId();
                ids.email = 'email'.gssGetId();
                ids.message = 'message'.gssGetId();
                ids.userName = 'userName'.gssGetId();
                ids.phoneNumber = 'phoneNumber'.gssGetId();
                ids.contactReason = 'ContactReason'.gssGetId();
                ids.organizationName = 'organizationName'.gssGetId();
                ids.organizationDomain = 'organizationDomain'.gssGetId();
                ids.accessCode = 'accessCode'.gssGetId();
                ids.chatLink = 'chatLink'.gssGetId();
                ids.tileTab = 'tileTab'.gssGetId();
                ids.breadCrumbs = 'breadCrumbs'.gssGetId();
                ids.contactHelpCenterSupport = 'contactHelpCenterSupport'.gssGetId();
                ids.searchResultLink = 'searchResultLink'.gssGetId();
                ids.contactUsPage = 'contactUsPage';
                ids.breadCrumbTileId = 'breadCrumbTileId';
                ids.breadCrumbTabId = 'breadCrumbTabId';
            })(ids = metaData.ids || (metaData.ids = {}));
        })(metaData = help.metaData || (help.metaData = {}));
        (function (metaData) {
            var values;
            (function (values) {
                values.topic = 'topic';
                values.tile = 'tile';
                values.tab = 'tab';
                values.popularTopic = 'popular';
                values.callBackFunction = 'GSS.help.backBrowserOnClick';
                values.appName = 'appName';
                values.portal = 'Portal';
                values.clientId = 'clientId';
            })(values = metaData.values || (metaData.values = {}));
        })(metaData = help.metaData || (help.metaData = {}));
        (function (metaData) {
            var props;
            (function (props) {
                props.gssName = 'data-gss-name';
                props.spaceName = 'data-gss-space-name';
                props.spaceText = 'data-gss-space-text';
                props.spaceCodeName = 'data-gss-code-name';
                props.spaceContent = 'data-gss-content';
                props.tileCodeName = 'data-gss-tile-code-name';
                props.topicUrl = 'data-gss-topic-url';
                props.topic = 'data-gss-topic';
                props.tabCodeName = 'data-gss-tab-code-name';
                props.tabContent = 'data-gss-tab-content';
                props.tab = 'data-gss-tab';
                props.homeContent = 'data-gss-home-content';
                props.homeCodeName = 'data-gss-home-code-name';
                props.questionCodeName = 'data-gss-question-code-name';
                props.questionContent = 'data-gss-question-content';
                props.tileContent = 'data-gss-tile-content';
                props.navLink = 'data-gss-nav-link';
                props.other = 'data-gss-other';
                props.trailType = 'data-gss-trail-type';
                props.defaultTabCode = 'data-gss-default-tab-code';
            })(props = metaData.props || (metaData.props = {}));
        })(metaData = help.metaData || (help.metaData = {}));
        (function (metaData) {
            var urls;
            (function (urls) {
                urls.supportTeams = '../_Help/SupportTeams';
                urls.getFAQContents = '../_Help/GetFAQContents';
                urls.contactThroughPhoneNumber = '../_Help/ContactUsThroughPhoneNumber';
                urls.contactThroughEmail = '../_Help/ContactUsThroughEmail';
                urls.contactUs = '../_Help/ContactUs';
                // New Help center
                urls.getTopic = '../_Help/Topic';
                urls.getTileContent = '../_Help/Tile';
                urls.getTabContent = '../_Help/Tab';
                urls.getHelpCenter = '../_Help/HelpCenter';
                urls.helpCenterSupport = '../_Help/HelpCenterSupport';
                urls.getSearchResults = '../_Help/GetSearchResults';
            })(urls = metaData.urls || (metaData.urls = {}));
        })(metaData = help.metaData || (help.metaData = {}));
        function init() {
            $(document).on('keypress', metaData.ids.searchTextBox, GSS.help.search);
            $(document).on('click', metaData.ids.phoneLink, GSS.help.callGallupSupport);
            $(document).on('click', metaData.ids.emailLink, GSS.help.signInForSupportModal);
            $(document).on('click', metaData.ids.contactUs, GSS.help.contactUs);
            $(document).on('click', metaData.ids.chatLink, GSS.help.chatWithGallupSupport);
            // New Help center with strengths
            $(document).on('click', GSS.data.constructDataAtt(GSS.help.metaData.props.gssName, GSS.help.metaData.values.tile), GSS.help.tile);
            $(document).on('click', GSS.help.metaData.props.topic.gssGetAtt(), GSS.help.topic);
            $(document).on('click', metaData.ids.contactHelpCenterSupport, GSS.help.contactHelpCenterSupport);
            $(document).on('keyup', GSS.data.constructIdAtt('organizationName'), GSS.help.getOrganizations);
            // remove previous on click event for tab
            $(GSS.help.metaData.props.tab.gssGetAtt()).off('click');
            $(document).on('click', GSS.help.metaData.props.tab.gssGetAtt(), GSS.help.tab);
            // create session for breadcrumbs but do not clear it (this effects the chat window session)
            GSS.portal.history.activategssHistory();
            saveSearchResultHistory(BreadCrumbs.TrailType.Home);
            // removing inline
            $(document).on('click', GSS.help.metaData.props.trailType.gssGetAtt('Home'), GSS.help.breadCrumbsOnClick);
            $(document).on('click', GSS.help.metaData.props.trailType.gssGetAtt('Tile'), GSS.help.breadCrumbsOnClick);
            $(document).on('click', GSS.help.metaData.props.trailType.gssGetAtt('StaticTab'), GSS.help.breadCrumbsOnClick);
            //Generic modal
            $(document).on('click', 'data-gss-name'.gssGetAtt('launch-signin-page'), GSS.help.launchSignInPage);
            $(document).on('click', 'data-gss-name'.gssGetAtt('contact-without-signin'), GSS.help.emailGallupSupport);
            // Launch Email Gallup Support Modal when redirected after successful sigin
            launchEmailGallupSupportModal();
        }
        help.init = init;
        function launchEmailGallupSupportModal() {
            if ((window.location.pathname.toLowerCase().indexOf('/support') != -1)) {
                var _session = new GSS.common.session(true);
                if (_session.getItem('postback') === undefined) {
                    _session.add({ id: 'postback', value: 'false' });
                    signInForSupportModal(this);
                }
            }
        }
        help.launchEmailGallupSupportModal = launchEmailGallupSupportModal;
        function pageOnChangeHelper(e) {
            var _pager = GSS.common.getPager.call(this, e.data.gridId);
            switch (e.data.gridId) {
                case 'searchResults':
                    GSS.help.pageOnChange(_pager.pageNumber, _pager.pageSize);
                    break;
            }
        }
        help.pageOnChangeHelper = pageOnChangeHelper;
        function getOrganizations(e) {
            var _url = "https://autocomplete.clearbit.com/v1/companies/suggest";
            var _data = { query: $("#organizationName").val() };
            var _req = GSS.common.request(_url, GSS.common.returnType.Json, false).get(_data);
            if ($("#organizationName").val() == '') {
                $('#disp').empty();
                $('#disp').removeClass('open');
            }
            _req.done(function (results) {
                if (results.length == 0) {
                    $("#organizationDomain").removeAttr('value');
                }
                $('#disp').addClass('open');
                var _val = '';
                _val = '<ul class="dropdown-menu" role="menu" aria-label="Organization Suggestions" style="margin-top: -1px; width: 100%;">';
                for (var i = 0; i < results.length; i++) {
                    _val += '<li role="presentation"> <a role="menuitem" data-portal-domain=' + results[i].domain + '>' + results[i].name + '</a> </li>';
                }
                _val += '</ul>';
                $('#disp').empty().get(0).innerHTML = _val;
                GSS.common.wait(300).done(function () {
                    $('#disp').find('a').each(function () {
                        var _this_1 = this;
                        $(this).on('click', function (e) {
                            $('#organizationName').val($(e.target).text());
                            $('#organizationDomain').val($(_this_1).data('portal-domain'));
                            $('#disp').empty();
                        });
                    });
                });
                var $listItems = $('#disp').find('li');
                $('#organizationName').on('keydown', function (e) {
                    var key = e.keyCode, $selected = $listItems.filter('.selected'), $current;
                    if (key != 40 && key != 38 && key != 9)
                        return;
                    $listItems.removeClass('selected');
                    if (key == 40) // Down key
                     {
                        if (!$selected.length || $selected.is(':last-child')) {
                            $current = $listItems.eq(0);
                        }
                        else {
                            $current = $selected.next();
                        }
                    }
                    else if (key == 38) // Up key
                     {
                        if (!$selected.length || $selected.is(':first-child')) {
                            $current = $listItems.last();
                        }
                        else {
                            $current = $selected.prev();
                        }
                    }
                    else if (key == 9) // Tab key
                     {
                        $('#disp').empty();
                        $('#disp').removeClass('open');
                    }
                    $current.addClass('selected');
                });
                $(document).on('click', function (e) {
                    var textbox = $('#organizationName');
                    var listbox = $('#disp');
                    if ((!textbox.is(e.target) && textbox.has(e.target).length === 0) &&
                        (!listbox.is(e.target) && listbox.has(e.target).length === 0)) {
                        $('#disp').empty();
                        $('#disp').removeClass('open');
                    }
                });
            }).fail(function (error) { void 0; }).always(function () { });
        }
        help.getOrganizations = getOrganizations;
        function callGallupSupport(e) {
            var _request = GSS.PortalContainer.Request.getByEvent(e, GSS.help.metaData.urls.contactThroughPhoneNumber, null, GSS.common.returnType.Json, GSS.common.modalProgress.Enable, false);
            _request.then(function (data) {
                if (data.Status == GSS.responseStatus.Success) {
                    GSS.PortalContainer.modalShowContent(data.Content);
                }
            })
                .always(function () {
                GSS.PortalContainer.progressHide();
            });
        }
        help.callGallupSupport = callGallupSupport;
        function chatWithGallupSupport(e) {
            var _this = e.currentTarget;
            var _href = $(_this).attr('href');
            if (_href == null || _href == undefined || _href.length <= 0) {
                e.preventDefault();
                return;
            }
        }
        help.chatWithGallupSupport = chatWithGallupSupport;
        function modalHide() {
            var _def = $.Deferred();
            var _data = {
                appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
            };
            var _request = GSS.PortalContainer.Request.getByEvent(this, GSS.help.metaData.urls.contactThroughEmail, _data, GSS.common.returnType.Json, GSS.common.modalProgress.Enable, false);
            _request.then(function (data) {
                GSS.PortalContainer.modalHide();
                GSS.common.wait(300).then(function () { _def.resolve(data); });
            }).fail(function (data) {
                _def.reject(data);
            });
            return _def.promise(GSS.data);
        }
        help.modalHide = modalHide;
        function emailGallupSupport(e) {
            modalHide().done(function (data) {
                if (data.Status == GSS.responseStatus.Success) {
                    $('.modal-backdrop').remove();
                    GSS.PortalContainer.modalShowContent(data.Content);
                }
            }).always(function () {
                GSS.PortalContainer.progressHide();
            });
        }
        help.emailGallupSupport = emailGallupSupport;
        function launchSignInPage(e) {
            var appName = GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal;
            var clientId = GSS.gssHistory.service.getParameterByName(metaData.values.clientId) || '';
            window.location.href = 'Support?appName=' + appName + '&gssClientId=' + clientId;
        }
        help.launchSignInPage = launchSignInPage;
        function signInForSupportModal(e) {
            var _data = {
                appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
            };
            var _request = GSS.PortalContainer.Request.getByEvent(e, '../_Help/GetSignInForSupportModal', _data, GSS.common.returnType.Json, GSS.common.modalProgress.Enable, false);
            _request.then(function (data) {
                if (data.Status == GSS.responseStatus.Success) {
                    GSS.PortalContainer.modalShowContent(data.Content);
                    if (typeof GSS.analytics !== 'undefined') {
                        GSS.analytics.HelpCenter.onContactUsEmailClick(data.IsAuthenticated);
                    }
                }
            }).always(function () {
                GSS.PortalContainer.progressHide();
            });
        }
        help.signInForSupportModal = signInForSupportModal;
        function contactUs() {
            var _data = {
                fullName: $(GSS.help.metaData.ids.fullName).val(),
                email: $(GSS.help.metaData.ids.email).val(),
                message: $(GSS.help.metaData.ids.message).val(),
                CaptchaValue: $('.g-recaptcha-response').val(),
                userName: $(GSS.help.metaData.ids.userName).val(),
                accessCode: $(GSS.help.metaData.ids.accessCode).val(),
                phoneNumber: $(GSS.help.metaData.ids.phoneNumber).val(),
                contactReason: $(GSS.help.metaData.ids.contactReason + " :selected").val(),
                organizationName: $(GSS.help.metaData.ids.organizationName).val(),
                organizationDomain: $(GSS.help.metaData.ids.organizationDomain).val(),
                appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
            };
            if (typeof GSS.analytics !== 'undefined') {
                GSS.analytics.HelpCenter.onContactUsSubmitFormButtonClick();
            }
            var _request = GSS.PortalContainer.Request.postByEvent(this, metaData.urls.contactUs, _data, GSS.common.returnType.Json, GSS.common.modalProgress.Enable, false);
            _request.then(function (data) {
                GSS.PortalContainer.modalShowContent(data.Content);
            })
                .always(function () {
                GSS.PortalContainer.progressHide();
            });
            ;
        }
        help.contactUs = contactUs;
        //===============================================================================================================================================//
        //================================================================New Help center================================================================//
        function contactHelpCenterSupport(e) {
            e.stopPropagation();
            e.preventDefault();
            var _data = {};
            var _urlParam = GSS.gssHistory.service.getParameterByName('clientId');
            if (_urlParam !== null && _urlParam !== undefined && _urlParam != "") {
                GSS.common.extendValue(_data, 'ClientId', _urlParam);
            }
            GSS.PortalContainer.Request.getByEvent(this, metaData.urls.helpCenterSupport, _data, GSS.common.returnType.Html, false)
                .then(function (data) {
                $(metaData.ids.divWidgetContent).empty().html(data);
                $(window).scrollTop(0);
            });
        }
        help.contactHelpCenterSupport = contactHelpCenterSupport;
        function topic(e) {
            e.preventDefault();
            var _url = $(this).gssData(metaData.props.topicUrl).gssToString();
            var _tile = GSS.gssHistory.service.getPageNameFromUrl(metaData.values.tile, _url);
            var _topic = GSS.gssHistory.service.getPageNameFromUrl(metaData.values.topic, _url);
            // push current state to history stack
            help.addTopicHistory.call(this);
            help.getTopic(_tile, _topic).
                done(function (data) {
                $(metaData.ids.divWidgetContent).empty().html(data);
                $('.gel-container').gssRemoveClass('container-fluid');
                $(window).scrollTop(0);
            });
        }
        help.topic = topic;
        // manage to push current data state to stack accordingly base on topic type: popular or regular
        function addTopicHistory() {
            var _topicType = $(this).gssData(metaData.props.topic).gssToString();
            var _url = $(this).gssData(metaData.props.topicUrl).gssToString();
            var _a = getActiveTabMetaData(), codeName = _a.codeName, tileCodeName = _a.tileCodeName, content = _a.content;
            var _topic = GSS.gssHistory.service.getPageNameFromUrl(metaData.values.topic, _url);
            var _this = this;
            if (_topicType === metaData.values.topic) {
                // scan active tab and retrieve its meta data
                var _b = getActiveTabMetaData(), codeName_1 = _b.codeName, tileCodeName_1 = _b.tileCodeName, content_1 = _b.content;
                var _topic_1 = GSS.gssHistory.service.getPageNameFromUrl(metaData.values.topic, _url);
                // this state data also includes tab's meta data
                GSS.gssHistory.manageWithRewriteUrl({
                    url: window.location.href,
                    callback: metaData.values.callBackFunction,
                    callbackData: {
                        appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                        clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                        searchText: $(metaData.ids.searchTextBox).val(),
                        url: window.location.href,
                        trailType: BreadCrumbs.TrailType.Topic,
                        topicType: _topicType,
                        codeName: codeName_1 || _this.dataset.gssQuestionCodeName,
                        tileCodeName: tileCodeName_1 || _this.dataset.gssTileCodeName,
                        content: content_1,
                        topic: _topic_1
                    }
                }, false, _url);
            }
            else {
                // this state data doesn't care about tab's meta data since it always go back to main page
                tileCodeName = this.dataset.gssTileCodeName;
                GSS.gssHistory.manageWithRewriteUrl({
                    url: window.location.href,
                    callback: metaData.values.callBackFunction,
                    callbackData: {
                        appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                        clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                        searchText: $(metaData.ids.searchTextBox).val(),
                        url: window.location.href,
                        trailType: BreadCrumbs.TrailType.Topic,
                        topicType: _topicType,
                        tileCodeName: tileCodeName,
                        topic: _topic
                    }
                }, false, _url);
            }
        }
        help.addTopicHistory = addTopicHistory;
        function tab(e) {
            var _this_1 = this;
            var _codeName = $(this).gssData(metaData.props.tabCodeName).gssToString();
            var _tileCodeName = $(this).gssData(metaData.props.tileCodeName).gssToString();
            var _content = $(this).gssData(metaData.props.tab).gssToString();
            // push current state to history stack
            GSS.gssHistory.manage({
                url: window.location.href,
                callback: metaData.values.callBackFunction,
                callbackData: {
                    appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                    clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                    codeName: _codeName,
                    tileCodeName: _tileCodeName,
                    url: metaData.urls.getTabContent,
                    content: _content,
                    trailType: BreadCrumbs.TrailType.Tab
                }
            }, true);
            help.getTab(_codeName, _tileCodeName, _content).
                done(function (data) {
                $(metaData.ids.divTileContent).empty().html(data);
                BreadCrumbs.createForTab.call(_this_1);
                $(window).scrollTop(0);
            });
        }
        help.tab = tab;
        function tile(e) {
            var _this_1 = this;
            var _codeName = $(this).gssData(metaData.props.spaceCodeName).gssToString();
            var _content = $(this).gssData(metaData.props.spaceContent).gssToString();
            var _homeContent = $(metaData.props.homeContent.gssGetAtt()).gssData(metaData.props.homeContent).gssToString();
            var _gssName = $(this).attr(metaData.props.gssName);
            GSS.gssHistory.manage({
                url: metaData.urls.getTileContent,
                callback: metaData.values.callBackFunction,
                callbackData: {
                    appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                    clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                    searchText: $(metaData.ids.searchTextBox).val(),
                    url: window.location.href,
                    codeName: _codeName,
                    content: _content,
                    homeContent: _homeContent,
                    trailType: BreadCrumbs.TrailType.Home
                }
            }, true);
            help.getTileContent(_codeName, _content, null).
                done(function (data) {
                $(metaData.ids.divWidgetContent).empty().html(data);
                BreadCrumbs.createForTile.call(_this_1);
                addDefaultTabHistory();
                $(window).scrollTop(0);
            });
        }
        help.tile = tile;
        function addDefaultTabHistory() {
            // scan active tab and retrieve its meta data
            var _a = getActiveTabMetaData(), codeName = _a.codeName, tileCodeName = _a.tileCodeName, content = _a.content;
            GSS.common.wait(100).done(function () {
                GSS.gssHistory.manage({
                    url: window.location.href,
                    callback: metaData.values.callBackFunction,
                    callbackData: {
                        appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                        clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                        codeName: codeName,
                        tileCodeName: tileCodeName,
                        url: metaData.urls.getTabContent,
                        content: content,
                        trailType: BreadCrumbs.TrailType.Tab
                    }
                }, true);
            });
        }
        help.addDefaultTabHistory = addDefaultTabHistory;
        function getTopic(tile, topic, calledByBackButtonMethod) {
            if (calledByBackButtonMethod === void 0) { calledByBackButtonMethod = false; }
            var _def = $.Deferred();
            var _data = {
                appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                tile: tile,
                topic: topic,
            };
            GSS.PortalContainer.Request.getByEvent(this, metaData.urls.getTopic, _data, GSS.common.returnType.Html, true)
                .then(function (data) {
                _def.resolve(data);
            }).fail(function (err) { _def.reject(err); });
            return _def.promise(GSS.data);
        }
        help.getTopic = getTopic;
        function getTab(tabCodeName, tileCodeName, tabContent, isCalledByBreadcrumb) {
            if (isCalledByBreadcrumb === void 0) { isCalledByBreadcrumb = false; }
            var _def = $.Deferred();
            var _data = {
                appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                Tab: tabCodeName,
                Tile: tileCodeName,
                content: tabContent
            };
            if (isCalledByBreadcrumb) {
                var _historyData = _data;
                var _content = document.getElementById(metaData.ids.breadCrumbTabId).getAttribute(metaData.props.spaceContent);
                _historyData = GSS.common.extendValue(_historyData, 'trailType', BreadCrumbs.TrailType.Tab);
                _historyData = GSS.common.extendValue(_historyData, 'content', _content);
                GSS.gssHistory.manage({
                    url: window.location.href,
                    callback: metaData.values.callBackFunction,
                    callbackData: _historyData
                }, true);
            }
            GSS.PortalContainer.Request.getByEvent(this, metaData.urls.getTabContent, _data, GSS.common.returnType.Html, true)
                .then(function (data) {
                _def.resolve(data);
            }).fail(function (err) { _def.reject(err); });
            return _def.promise(GSS.data);
        }
        help.getTab = getTab;
        function getTileContent(tileCodeName, content, searchText, isCalledByBreadcrumb) {
            if (isCalledByBreadcrumb === void 0) { isCalledByBreadcrumb = false; }
            var _def = $.Deferred();
            var _data = {
                appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                clientId: GSS.gssHistory.service.getParameterByName(metaData.values.clientId),
                Tile: tileCodeName,
                content: content,
                searchText: searchText,
                url: metaData.urls.getTileContent
            };
            var _historyData = _data;
            if (isCalledByBreadcrumb) {
                var _isAtTopic = document.getElementById(metaData.values.topic);
                var _defaultTabCodeName = _isAtTopic ? document.getElementById(metaData.ids.breadCrumbTileId).getAttribute(metaData.props.defaultTabCode) :
                    $(metaData.ids.tileTab).find('li').find('a')[0].dataset.gssTabCodeName;
                _historyData = GSS.common.extendValue(_historyData, 'trailType', BreadCrumbs.TrailType.Tab);
                _historyData.url = metaData.urls.getTabContent;
                _historyData = GSS.common.extendValue(_historyData, 'codeName', _defaultTabCodeName);
                GSS.gssHistory.manage({
                    url: window.location.href,
                    callback: metaData.values.callBackFunction,
                    callbackData: _historyData
                }, true);
            }
            else {
                _historyData = GSS.common.extendValue(_historyData, 'trailType', BreadCrumbs.TrailType.Home);
                GSS.gssHistory.manage({
                    url: window.location.href,
                    callback: metaData.values.callBackFunction,
                    callbackData: _historyData
                }, true);
            }
            GSS.PortalContainer.Request.getByEvent(this, metaData.urls.getTileContent, _data, GSS.common.returnType.Html, true)
                .then(function (data) {
                _def.resolve(data);
            }).fail(function (err) { _def.reject(err); });
            return _def.promise(GSS.data);
        }
        help.getTileContent = getTileContent;
        function getActiveTabMetaData() {
            var _codeName, _tileCodeName, _content;
            // scan active tab and retrieve its meta data
            $(metaData.ids.tileTab).find('li').each(function (i, v) {
                if ($(this).hasClass('active')) {
                    var _$el = $(this).find('a');
                    _codeName = $(_$el).gssData(metaData.props.tabCodeName).gssToString();
                    _tileCodeName = $(_$el).gssData(metaData.props.tileCodeName).gssToString();
                    _content = $(_$el).gssData(metaData.props.tab).gssToString();
                }
            });
            return { codeName: _codeName, tileCodeName: _tileCodeName, content: _content };
        }
        help.getActiveTabMetaData = getActiveTabMetaData;
        function breadCrumbsOnClick(e) {
            var _this_1 = this;
            if (e != null) {
                e.stopPropagation();
                e.preventDefault();
            }
            var _codeName = $(this).gssData(metaData.props.spaceCodeName).gssToString();
            var _content = $(this).gssData(metaData.props.spaceContent).gssToString();
            var _trailType = $(this).gssData(metaData.props.trailType).gssToString();
            switch (_trailType) {
                case BreadCrumbs.TrailType.Home:
                    var _clientId = GSS.gssHistory.service.getParameterByName(metaData.values.clientId);
                    var _clientIdParam = _clientId !== undefined && _clientId !== null ? "&" + metaData.values.clientId + '=' + GSS.gssHistory.service.getParameterByName(metaData.values.clientId) : "";
                    var _url = metaData.urls.getHelpCenter + '?' + metaData.values.appName + '=' + GSS.gssHistory.service.getParameterByName(metaData.values.appName) + _clientIdParam || metaData.values.portal;
                    window.location.assign(_url);
                    break;
                case BreadCrumbs.TrailType.Tile:
                    help.getTileContent(_codeName, _content, null, true).
                        done(function (data) {
                        $(metaData.ids.divWidgetContent).empty().html(data);
                        BreadCrumbs.createForTile.call(_this_1);
                        $(window).scrollTop(0);
                    });
                    break;
                case BreadCrumbs.TrailType.Tab:
                    var _tileCodeName_1 = $(this).gssData(metaData.props.other).gssToString();
                    help.getTab(_codeName, _tileCodeName_1, null, true).
                        done(function (data) {
                        $(metaData.ids.divTileContent).empty().html(data);
                        GSS.common.wait(200).done(function () {
                            BreadCrumbs.createForTab(_content, _codeName, _tileCodeName_1);
                        });
                        $(window).scrollTop(0);
                    });
                    break;
                case BreadCrumbs.TrailType.StaticTab:
                    var _staticTileCodeName_1 = $(this).gssData(metaData.props.other).gssToString();
                    var _staticTileContent_1 = $(this).gssData(metaData.props.tileContent).gssToString();
                    help.getTab(_codeName, _staticTileCodeName_1, null, true).
                        done(function (data) {
                        $(metaData.ids.divTileContent).empty().html(data);
                        GSS.common.wait(200).done(function () {
                            BreadCrumbs.createForStaticTab(_staticTileCodeName_1, _staticTileContent_1, _codeName, _content);
                        });
                        $(window).scrollTop(0);
                    });
                    break;
            }
        }
        help.breadCrumbsOnClick = breadCrumbsOnClick;
        function backBrowserOnClick(stateData) {
            var _clientId = GSS.gssHistory.service.getParameterByName(metaData.values.clientId);
            var _clientIdParam = _clientId !== undefined && _clientId !== null ? "&" + metaData.values.clientId + '=' + GSS.gssHistory.service.getParameterByName(metaData.values.clientId) : "";
            _clientIdParam = GSS.common.isNotNullOrEmpty(_clientIdParam) ? _clientIdParam : "";
            var _url = metaData.urls.getHelpCenter + '?' + metaData.values.appName + '=' + stateData.appName + _clientIdParam;
            var _isAtContactUs = document.getElementById(metaData.ids.contactUsPage);
            if (_isAtContactUs) {
                stateData.trailType = BreadCrumbs.TrailType.Home;
            }
            if (GSS.common.isNotNullOrEmpty(stateData.trailType)) {
                switch (stateData.trailType) {
                    case BreadCrumbs.TrailType.Home:
                        window.location.assign(_url);
                        break;
                    case BreadCrumbs.TrailType.Tile:
                        if (stateData.url === metaData.urls.getTileContent) {
                            help.getTileContent(stateData.codeName, stateData.content, stateData.searchText).
                                done(function (data) {
                                $(metaData.ids.divWidgetContent).empty().html(data);
                                BreadCrumbs.createForTile(stateData.codeName, stateData.content, stateData.homeContent);
                                $(window).scrollTop(0);
                            });
                        }
                        else {
                            window.location.assign(stateData.url);
                        }
                        break;
                    case BreadCrumbs.TrailType.Tab:
                        help.reCreateTab(stateData);
                        break;
                    case BreadCrumbs.TrailType.Topic:
                        // do not change the variable names here.  Some are for server side consumption.
                        var _tile = stateData.tile || stateData.tileCodeName;
                        var _topic = stateData.topic;
                        help.getTopic(_tile, _topic, true).
                            done(function (data) {
                            $(metaData.ids.divWidgetContent).empty().html(data);
                            $(window).scrollTop(0);
                        });
                        break;
                    case BreadCrumbs.TrailType.Search:
                        GSS.PortalContainer.Request.getByEvent(this, stateData.url, stateData, GSS.common.returnType.Html, true)
                            .done(function (data) {
                            $(metaData.ids.divWidgetContent).empty().html(data);
                            GSS.common.wait(100).done(function () { $(metaData.ids.searchTextBox).val(stateData.searchText).trigger('focus'); });
                        });
                        $(window).scrollTop(0);
                        break;
                }
            }
        }
        help.backBrowserOnClick = backBrowserOnClick;
        function reCreateTab(stateData) {
            // the stateData.Tab and stateData.Tile property names are named as such for server side consumption.  Do not change the property names.
            stateData.codeName = stateData.codeName || stateData.Tab || stateData.Tile;
            stateData.tileCodeName = stateData.tileCodeName || stateData.Tile;
            help.getTab(stateData.codeName, stateData.tileCodeName, stateData.content).
                done(function (data) {
                $(metaData.ids.divTileContent).empty().html(data);
                GSS.common.wait(200).done(function () {
                    BreadCrumbs.createForTab(stateData.content, stateData.codeName, stateData.tileCodeName);
                });
                $(window).scrollTop(0);
            }).
                fail(function (data) {
                var _clientId = GSS.gssHistory.service.getParameterByName(metaData.values.clientId);
                var _clientIdParam = _clientId !== undefined && _clientId !== null ? "&" + metaData.values.clientId + '=' + GSS.gssHistory.service.getParameterByName(metaData.values.clientId) : "";
                _clientIdParam = GSS.common.isNotNullOrEmpty(_clientIdParam) ? _clientIdParam : "";
                var _url = metaData.urls.getHelpCenter + '?' + metaData.values.appName + '=' + stateData.appName + _clientIdParam;
                window.location.assign(_url);
            });
        }
        help.reCreateTab = reCreateTab;
        var BreadCrumbs;
        (function (BreadCrumbs) {
            var TrailType;
            (function (TrailType) {
                TrailType.Home = 'Home';
                TrailType.Tile = 'Tile';
                TrailType.Tab = 'Tab';
                TrailType.StaticTab = 'StaticTab';
                TrailType.Topic = 'Topic';
                TrailType.Search = 'Search';
            })(TrailType = BreadCrumbs.TrailType || (BreadCrumbs.TrailType = {}));
            function create() {
                var _ul = $('<ul/>').attr({ 'class': 'c-breadcrumb__items' });
                var _sessionItems = new GSS.common.session(true).getItems();
                var _helpCenterSessionItems = [];
                // Add only the help center items to the new array
                for (var _i = 0, _sessionItems_1 = _sessionItems; _i < _sessionItems_1.length; _i++) {
                    var element = _sessionItems_1[_i];
                    if (element.id in TrailType) {
                        _helpCenterSessionItems.push(element);
                    }
                }
                _helpCenterSessionItems.forEach(function (v, i) {
                    createItem(v.value, _helpCenterSessionItems.length == i + 1, v.values['trailCodeName'], v.values['trailType'], v.values['other']).appendTo(_ul);
                });
                var _nav = $('<nav/>').attr({ 'class': 'c-breadcrumb', 'aria-label': 'Breadcrumb' }).append(_ul);
                $(metaData.ids.breadCrumbs).empty().append(_nav);
                $(metaData.props.navLink.gssGetAtt()).off('click');
                $(metaData.props.navLink.gssGetAtt()).on('click', breadCrumbsOnClick);
                $(metaData.props.navLink.gssGetAtt()).on('click', GSS.analytics.HelpCenter.onCategoryClick);
            }
            function createItem(content, isCurr, codeName, trailType, other) {
                if (isCurr === void 0) { isCurr = false; }
                if (codeName === void 0) { codeName = 'codename'; }
                if (trailType === void 0) { trailType = TrailType.Home; }
                if (other === void 0) { other = null; }
                var _li = $('<li/>').attr({ 'class': 'c-breadcrumb__item' });
                var _navItem = $('<a/>').attr({ 'href': 'javascript:void(0)', 'class': 'c-breadcrumb__link', 'data-gss-code-name': codeName, 'data-gss-content': content, 'data-gss-trail-type': trailType, 'data-gss-nav-link': true, 'data-gss-other': other, 'data-ga-event': 'help-center-category-click', 'data-ga-label': content });
                var _currItem = $('<span/>').attr({ 'class': 'c-breadcrumb__current' });
                if (isCurr) {
                    return _li.append(_currItem.append(content));
                }
                else {
                    return _li.append(_navItem.append(content));
                }
            }
            function manageTrail(trailType, trailValue, codeName, homeTrailValue, other) {
                if (codeName === void 0) { codeName = 'codeName'; }
                var _session = new GSS.common.session(true);
                switch (trailType) {
                    case TrailType.Home:
                    case TrailType.Tile:
                        _session.remove(TrailType.Home);
                        _session.remove(TrailType.Tile);
                        _session.remove(TrailType.Tab);
                        _session.remove(TrailType.Topic);
                        _session.add({ id: TrailType.Home, value: homeTrailValue || 'Home', values: { trailType: TrailType.Home, trailCodeName: codeName, other: other } });
                        break;
                    case TrailType.Tab:
                        _session.remove(TrailType.Tab);
                        _session.remove(TrailType.Topic);
                        break;
                    case TrailType.Topic:
                        _session.remove(TrailType.Topic);
                        break;
                }
                _session.add({ id: trailType, value: trailValue, values: { trailType: trailType, trailCodeName: codeName, other: other } });
            }
            function scanActiveTab() {
                $(metaData.ids.tileTab).find('li').each(function (i, v) {
                    if ($(this).hasClass('active')) {
                        var _tabText = $(this).find('a').find('span').text();
                        manageTrail(TrailType.Tab, _tabText);
                    }
                });
            }
            function createForTile(content, codeName, homeContent) {
                var _content = content || $(this).gssData(metaData.props.spaceContent).gssToString();
                var _codeName = codeName || $(this).gssData(metaData.props.spaceCodeName).gssToString();
                var _homeContent = homeContent || $(metaData.props.homeContent.gssGetAtt()).gssData(metaData.props.homeContent).gssToString();
                manageTrail(BreadCrumbs.TrailType.Tile, _content, _codeName, _homeContent);
                GSS.common.wait(200).done(function () {
                    scanActiveTab();
                    create();
                });
            }
            BreadCrumbs.createForTile = createForTile;
            function createForTab(tabContent, tabCodeName, tileCodeName) {
                var _tabContent = tabContent || $(this).gssData(metaData.props.tab).gssToString();
                var _tabCodeName = tabCodeName || $(this).gssData(metaData.props.tabCodeName).gssToString();
                var _tileCodeName = tileCodeName || $(this).gssData(metaData.props.tileCodeName).gssToString();
                manageTrail(BreadCrumbs.TrailType.Tab, _tabContent, _tileCodeName, _tabCodeName);
                GSS.common.wait(100).done(function () {
                    create();
                });
            }
            BreadCrumbs.createForTab = createForTab;
            function createForStaticTab(tileCodeName, tileContent, tabCodeName, tabContent) {
                var _homeContent = $(metaData.props.homeContent.gssGetAtt()).gssData(metaData.props.homeContent).gssToString();
                var _homeCodeName = $(metaData.props.homeCodeName.gssGetAtt()).gssData(metaData.props.homeCodeName).gssToString();
                var _session = new GSS.common.session(true);
                // session.remove() instead of session.clear();
                _session.remove(TrailType.Home);
                _session.remove(TrailType.Tile);
                _session.remove(TrailType.Tab);
                _session.remove(TrailType.Topic);
                _session.remove(TrailType.StaticTab);
                _session.remove(TrailType.Search);
                _session.add({ id: BreadCrumbs.TrailType.Home, value: _homeContent, values: { trailType: BreadCrumbs.TrailType.Home, trailCodeName: _homeCodeName } });
                _session.add({ id: BreadCrumbs.TrailType.Tile, value: tileContent, values: { trailType: BreadCrumbs.TrailType.Tile, trailCodeName: tileCodeName } });
                _session.add({ id: BreadCrumbs.TrailType.Tab, value: tabContent, values: { trailType: BreadCrumbs.TrailType.Tab, trailCodeName: tabCodeName, other: tileCodeName } });
                GSS.common.wait(100).done(function () {
                    create();
                    $(metaData.ids.tileTab).find('li').each(function (i, v) {
                        if ($(this).find('a').find('span').text() == tabContent) {
                            $(this).gssAddClass('active');
                        }
                    });
                });
            }
            BreadCrumbs.createForStaticTab = createForStaticTab;
            function createForTopic() {
                var _questionCodeName = $(this).gssData(metaData.props.questionCodeName).gssToString();
                var _questionContent = $(this).gssData(metaData.props.questionContent).gssToString();
                var _tileCodeName = $(this).gssData(metaData.props.tileCodeName).gssToString();
                var _tileContent = $(this).gssData(metaData.props.tileContent).gssToString();
                var _tabCodeName = $(this).gssData(metaData.props.tabCodeName).gssToString();
                var _tabContent = $(this).gssData(metaData.props.tabContent).gssToString();
                var _homeContent = $(metaData.props.homeContent.gssGetAtt()).gssData(metaData.props.homeContent).gssToString();
                var _homeCodeName = $(metaData.props.homeCodeName.gssGetAtt()).gssData(metaData.props.homeCodeName).gssToString();
                var _session = new GSS.common.session(true);
                // session.remove() instead of session.clear();
                _session.remove(TrailType.Home);
                _session.remove(TrailType.Tile);
                _session.remove(TrailType.Tab);
                _session.remove(TrailType.Topic);
                _session.remove(TrailType.StaticTab);
                _session.remove(TrailType.Search);
                _session.add({ id: BreadCrumbs.TrailType.Home, value: _homeContent, values: { trailType: BreadCrumbs.TrailType.Home, trailCodeName: _homeCodeName } });
                _session.add({ id: BreadCrumbs.TrailType.Tile, value: _tileContent, values: { trailType: BreadCrumbs.TrailType.Tile, trailCodeName: _tileCodeName } });
                _session.add({ id: BreadCrumbs.TrailType.Tab, value: _tabContent, values: { trailType: BreadCrumbs.TrailType.Tab, trailCodeName: _tabCodeName, other: _tileCodeName } });
                _session.add({ id: BreadCrumbs.TrailType.Topic, value: _questionContent, values: { trailType: BreadCrumbs.TrailType.Topic, trailCodeName: _questionCodeName } });
                GSS.common.wait(100).done(function () {
                    create();
                });
            }
            BreadCrumbs.createForTopic = createForTopic;
        })(BreadCrumbs = help.BreadCrumbs || (help.BreadCrumbs = {}));
        function pageOnChange(pageIndex, pageSize) {
            var _data = {
                PageNumber: (pageIndex != null ? pageIndex : 1),
                PageSize: (pageSize != null ? pageSize : GSS.common.pagination.getPageSize('searchResults')),
                SearchText: $(metaData.ids.searchTextBox).val() || '',
            };
            help.getSearchResults(_data.SearchText, _data.PageSize.toString(), _data.PageNumber.toString()).done(function (data) {
                $('#searchResults').html(data);
                GSS.common.wait(100).done(function () { $('#SearchText').val(_data.SearchText); });
                GSS.common.addPaginationListeners('searchResults', GSS.help.pageOnChangeHelper);
            });
        }
        help.pageOnChange = pageOnChange;
        function search(e) {
            if (e.keyCode === 13) {
                e.stopPropagation();
                e.preventDefault();
                var _searchValue_1 = $(metaData.ids.searchTextBox).val() || '';
                if (typeof GSS.analytics !== 'undefined') {
                    GSS.analytics.HelpCenter.onSearch(_searchValue_1);
                }
                help.getSearchResults(_searchValue_1).
                    done(function (data) {
                    $(metaData.ids.divWidgetContent).empty().html(data);
                    GSS.common.wait(100).done(function () {
                        $(metaData.props.spaceName.gssGetAtt()).gssRemoveClass('is-active');
                        $(metaData.ids.searchTextBox).val(_searchValue_1).trigger('focus');
                        GSS.common.addPaginationListeners('searchResults', GSS.help.pageOnChangeHelper);
                    });
                    $(window).scrollTop(0);
                });
            }
        }
        help.search = search;
        function getSearchResults(searchText, pageSize, pageNumber) {
            var _def = $.Deferred();
            var _a = getActiveTabMetaData(), codeName = _a.codeName, tileCodeName = _a.tileCodeName, content = _a.content;
            var _data = {
                appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                searchText: searchText,
                pageNumber: pageNumber || '1',
                pageSize: pageSize || '10',
                clientId: GSS.gssHistory.service.getParameterByName('gssClientId') || '',
                codeName: codeName,
                tileCodeName: tileCodeName
            };
            saveSearchResultHistory(BreadCrumbs.TrailType.Search, _data.searchText, _data.pageNumber, _data.pageSize, _data.codeName, _data.tileCodeName);
            GSS.PortalContainer.Request.getByEvent(this, metaData.urls.getSearchResults, _data, GSS.common.returnType.Html, true)
                .then(function (data) {
                _def.resolve(data);
            }).fail(function (err) { _def.reject(err); });
            return _def.promise(GSS.data);
        }
        help.getSearchResults = getSearchResults;
        function saveSearchResultHistory(trailType, searchText, pageNumber, pageSize, _codeName, _tileCodeName) {
            GSS.gssHistory.manage({
                url: window.location.href,
                callback: metaData.values.callBackFunction,
                callbackData: {
                    appName: GSS.gssHistory.service.getParameterByName(metaData.values.appName) || metaData.values.portal,
                    trailType: trailType,
                    searchText: searchText || '',
                    pageNumber: pageNumber || '10',
                    pageSize: pageSize || '1',
                    url: metaData.urls.getSearchResults,
                    codeName: _codeName,
                    tileCodeName: _tileCodeName
                }
            }, true);
        }
        help.saveSearchResultHistory = saveSearchResultHistory;
    })(help = GSS.help || (GSS.help = {}));
})(GSS || (GSS = {}));
$(GSS.help.init);
//# sourceMappingURL=GSS.help.js.map